<div
    fxFlex
    fxLayoutAlign="start start"
    fxLayout.lt-lg="column"
    fxLayoutAlign.lt-lg="start center"
    fxLayoutGap="30px"
    fxLayoutGap.lt-lg="20px"
>
    <div class="fuse-card mt-24" fxLayout="column">
        <div class="p-16">
            <div class="h1 pr-16">Notificaciones</div>
        </div>

        <mat-list>
            <mat-list-item
                *ngFor="let notificacion of perfilUsuario.estadoNotificaciones"
            >
                <h3 matLine>
                    <strong>{{ notificacion.descripcion }}</strong>
                </h3>
                <p matLine>
                    <mat-slide-toggle
                        [checked]="notificacion.activa"
                        (change)="toggleEstadoNotificacion(notificacion)"
                    >
                        {{ notificacion.activa ? "Activada" : "Desactivada" }}
                    </mat-slide-toggle>
                </p>
            </mat-list-item>
        </mat-list>
    </div>

    <div
        fxFlex
        fxLayout="row"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="start center"
        fxLayoutAlign="end end"
        style="height: 100%; width: 100%"
    >
        <button
            mat-raised-button
            color="accent"
            (click)="guardar()"
            class="mt-16"
        >
            Guardar
        </button>
    </div>
</div>
